/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_CloseInputs */

const bn_action_close = /** @type {(inputs: Action_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বন্ধ`)
};

const de_action_close = /** @type {(inputs: Action_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const el_action_close = /** @type {(inputs: Action_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κοντά`)
};

const en_action_close = /** @type {(inputs: Action_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const es_action_close = /** @type {(inputs: Action_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca`)
};

const fr_action_close = /** @type {(inputs: Action_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const hi_action_close = /** @type {(inputs: Action_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंद करना`)
};

const hu_action_close = /** @type {(inputs: Action_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Közeli`)
};

const id_action_close = /** @type {(inputs: Action_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menutup`)
};

const it_action_close = /** @type {(inputs: Action_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vicino`)
};

const ja_action_close = /** @type {(inputs: Action_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近い`)
};

const ko_action_close = /** @type {(inputs: Action_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`닫다`)
};

const nl_action_close = /** @type {(inputs: Action_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dichtbij`)
};

const pl_action_close = /** @type {(inputs: Action_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamknąć`)
};

const pt_action_close = /** @type {(inputs: Action_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

const ru_action_close = /** @type {(inputs: Action_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрывать`)
};

const sv_action_close = /** @type {(inputs: Action_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nära`)
};

const tr_action_close = /** @type {(inputs: Action_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapalı`)
};

const uk_action_close = /** @type {(inputs: Action_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрити`)
};

const vi_action_close = /** @type {(inputs: Action_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đóng`)
};

const zh_action_close = /** @type {(inputs: Action_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭`)
};

const zh_hant_action_close = /** @type {(inputs: Action_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`關閉`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Action_CloseInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const action_close = /** @type {((inputs?: Action_CloseInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_CloseInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_action_close(inputs)
	if (locale === "de") return de_action_close(inputs)
	if (locale === "el") return el_action_close(inputs)
	if (locale === "en") return en_action_close(inputs)
	if (locale === "es") return es_action_close(inputs)
	if (locale === "fr") return fr_action_close(inputs)
	if (locale === "hi") return hi_action_close(inputs)
	if (locale === "hu") return hu_action_close(inputs)
	if (locale === "id") return id_action_close(inputs)
	if (locale === "it") return it_action_close(inputs)
	if (locale === "ja") return ja_action_close(inputs)
	if (locale === "ko") return ko_action_close(inputs)
	if (locale === "nl") return nl_action_close(inputs)
	if (locale === "pl") return pl_action_close(inputs)
	if (locale === "pt") return pt_action_close(inputs)
	if (locale === "ru") return ru_action_close(inputs)
	if (locale === "sv") return sv_action_close(inputs)
	if (locale === "tr") return tr_action_close(inputs)
	if (locale === "uk") return uk_action_close(inputs)
	if (locale === "vi") return vi_action_close(inputs)
	if (locale === "zh") return zh_action_close(inputs)
	return zh_hant_action_close(inputs)
});